export default __webpack_public_path__ + "static/media/parallel-at-the-end.7e139840.png";